import { baseURL } from '../../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';
// 查询学习档案个人字段数据
export const getPersonFieldDataApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/study-data/v1/user/get-person-field-data', data);
};
// 查询学员项目学习档案数据
export const getStudentProjectArchivesApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/study-data/v1/user/get-study-data', data);
};
// 学员学习档案导出
export const exportStudentArchivesApi = (data) => {
    // 下载学习档案需要单独设置超时时间：2分钟
    return hMacAjax.post(baseURL + '/grt-user-center-service/api/v1/export', data ,{timeout:120000});
};